import React from 'react';
import { CheckCircleSolid } from '@fff-web/fff-ui-shared/Icon';
import classNames from 'classnames';
import {
  passwordContainsNumber,
  passwordContainsSpecialCharacter,
  passwordContainsUpperAndLowerCase,
} from '../../../../utils/isValidPassword';
import styles from './PasswordToolTip.module.css';
import { PASSWORD_TOOLTIP_CONTAINER } from '../../../../utils/constants';

interface PasswordToolTipProps {
  password: string;
}

const PasswordToolTip: React.FunctionComponent<PasswordToolTipProps> = ({ password }) => (
  <div className={styles.passwordTooltip} data-testid={PASSWORD_TOOLTIP_CONTAINER}>
    <div className={styles.triangleWithShadow} />
    <p className={styles.passwordTooltipTitle}>Your password must have: </p>
    <div className={styles.passwordTooltipRow}>
      <div
        className={classNames(styles.passwordTooltipCheck, {
          [styles.passwordTooltipCheckValid]: password.length > 7,
        })}
      >
        {password.length > 7 && <CheckCircleSolid fill="#9CD320" />}
      </div>
      <p className={styles.passwordTooltipTip}>8 or more characters</p>
    </div>
    <div className={styles.passwordTooltipRow}>
      <div
        className={classNames(styles.passwordTooltipCheck, {
          [styles.passwordTooltipCheckValid]: passwordContainsUpperAndLowerCase(password),
        })}
      >
        {passwordContainsUpperAndLowerCase(password) && <CheckCircleSolid fill="#9CD320" />}
      </div>
      <p className={styles.passwordTooltipTip}>Uppercase and lowercase letters</p>
    </div>
    <div className={styles.passwordTooltipRow}>
      <div
        className={classNames(styles.passwordTooltipCheck, {
          [styles.passwordTooltipCheckValid]: passwordContainsSpecialCharacter(password),
        })}
      >
        {passwordContainsSpecialCharacter(password) && <CheckCircleSolid fill="#9CD320" />}
      </div>
      <p className={styles.passwordTooltipTip}>At least 1 special character(e.g.!@#$%^)</p>
    </div>
    <div className={styles.passwordTooltipRow}>
      <div
        className={classNames(styles.passwordTooltipCheck, {
          [styles.passwordTooltipCheckValid]: passwordContainsNumber(password),
        })}
      >
        {passwordContainsNumber(password) && <CheckCircleSolid fill="#9CD320" />}
      </div>
      <p className={styles.passwordTooltipTip}>At least 1 number</p>
    </div>
  </div>
);

export default PasswordToolTip;
